import { render, staticRenderFns } from "./CustomerManage.vue?vue&type=template&id=8890984e"
import script from "./CustomerManage.vue?vue&type=script&lang=js"
export * from "./CustomerManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports